<div id="wrapper">
    <div>
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
    </div>
    <div>
        <app-tab-nav 
            [visible]="false"
            (updatePostpaid)="this.postpago=$event"
            (updatePrepaid)="this.prepago=$event"
            (updateFixed)="this.telefoniaFijo=$event"
            (updateTotalAccountList)="this.totalAccountList=$event"
            (updateCurrentList)="this.currentList=$event"
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()">
        </app-tab-nav>
    </div>
    <div class="allcont logsize">
        <div class="basicrow m-bott">
            <div class="basicrow">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                            <div class="basicrow">
                                <div class="fulltitle m-top-i f-btitle">
                                    <span class="icon-dash-21"></span> Redimir
                                </div>
                            </div>
                            <div class="basicrow f-black roboto-m f-mildt m-top">
                                Bienvenido/a<br>
                                <span class="f-red">{{this.accountName}}</span>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                            <div class="basicrow rel bg-gray-iii no-ptop m-top-i">
                                <div class="row">
                                    <div class="col-xs-6 col-sm-3 col-md-3 col-lg-3 h-mtop-i">
                                        <div class="basicrow f-black roboto-b text-center respdef-f">
                                            <span class="f-reg">
                                                Amigos Referidos
                                            </span><br />
                                            <span class="f-lsemi f-red">
                                                {{this.TotalReferer}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-3 col-md-3 col-lg-3 h-mtop-i">
                                        <div class="basicrow f-black roboto-b text-center respdef-f">
                                            <span class="f-reg">
                                                Amigos Pendientes
                                            </span><br />

                                            <span class="f-lsemi f-red">
                                                {{this.TotalPending}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-3 col-md-3 col-lg-3 h-mtop-i">
                                        <div class="basicrow f-black roboto-b text-center respdef-f">
                                            <span class="f-reg">
                                                Amigos Redimidos
                                            </span><br />
                                            <span class="f-lsemi f-red">
                                                {{this.CountRedeems}}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-6 col-sm-3 col-md-3 col-lg-3 h-mtop-i">
                                        <div class="basicrow f-black roboto-b text-center respdef-f">
                                            <span class="f-reg">
                                                Descuentos Disponibles
                                            </span><br />
                                            <span class="f-lsemi f-blue">
                                                <span *ngIf="!this.porcentajeDisponible">
                                                    <span *ngIf="!this.porcentajeAbsoluto">$</span>
                                                    {{this.countDisponible}}
                                                <span *ngIf="this.porcentajeAbsoluto">%</span></span>
                                                <span *ngIf="this.porcentajeDisponible">50%</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row rowsusc-redeem">
                                <div class="col-xs-6 h-mtop-i">
                                    <div class="basicrow f-black roboto-b text-center respdef-f">
                                        <span class="basicrow f-black roboto-m f-mildt m-top">
                                            Cuenta <span class="f-gray">{{this.selectBan}}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-xs-6 h-mtop-i">
                                    <div class="basicrow f-black roboto-b text-center respdef-f">
                                        <span class="basicrow f-black roboto-m f-mildt m-top">
                                            Suscriptor <span class="f-gray">{{this.currentSuscriber}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-bott-i">
                    <div class="container">
                        <div class="basicrow m-top-i">
                            <div class="onew-title vcenter">
                                <div class="tabcell">
                                    Hist&oacute;rico de beneficios obtenidos
                                </div>
                            </div>
                            <div class="onew-table">
                                <div *ngIf="this.objItemsReferr.length==0" class="noDisp">
                                    No hay cupones Disponibles
                                </div>
                                <div *ngIf="this.objItemsReferr.length>0">
                                    <div *ngFor="let credit of this.objItemsReferr; let i=index" class="onew-cont">
                                        <div class="onew-spc-i roboto-b vcenter">
                                            <div class="tabcell">
                                                <i class="fa fa-ticket" aria-hidden="true"></i> 
                                                <label *ngIf="credit.discountType=='$'">{{credit.discountType}}</label>
                                                    {{credit.discountMember}}
                                                <label *ngIf="credit.discountType=='%'">{{credit.discountType}}</label>
                                            </div>
                                        </div>
                                        <div class="onew-spc-ii roboto-b vcenter">
                                            <div class="tabcell">
                                                {{credit.ReferAccountName}}
                                            </div>
                                        </div>
                                        <div class="onew-spc-iii text-center vcenter">
                                            <div class="tabcell">
                                                Vigente desde el {{credit.validFromDate}} al {{credit.validUntilDate}}
                                            </div>
                                        </div>
                                        <div class="onew-spc-iii roboto-b text-center vcenter">
                                            <div class="tabcell">
                                                Estatus: {{credit.cuponStatus}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="basicrow m-top-i text-center" id="last-div">
                            <div class="basicrow f-mildt f-black roboto-m">
                                Seleccione la siguiente opción para aplicar el descuento en su factura.
                            </div>
                            <div class="basicrow">
                                <a href="/home" class="redeembox">
                                    <i class="fa fa-money" aria-hidden="true"></i>
                                    Pagar Factura
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>